import { apiGet } from './client'

export interface HealthResponse {
  status: string
  components: {
    compass_postgres: { status: string; version?: string; plan_count?: number; plan_version_count?: number }
    neo4j: { status: string; uri?: string }
  }
}

export interface SchedulerJob {
  id: string
  next_run_time: string | null
  interval_seconds: number | null
}

export interface SchedulerStatus {
  enabled: boolean
  running: boolean
  market_open_now: boolean
  jobs: SchedulerJob[]
  market_open_et: string
  market_close_et: string
  consecutive_error_threshold: number
}

export interface WsStatus {
  running: boolean
  connected: boolean
  ws_url: string | null
  last_event_at: number | null
  events_received: number
  reconnects: number
  last_error: string | null
  known_accounts: string[]
}

export interface CircuitBreakerSnapshot {
  account_alias: string
  asof: string
  capital_base: number
  today_realized: number
  aggregate_unrealized: number
  rolling_realized: number
  rolling_window_days: number
  today_pnl_total: number
  today_pnl_pct: number
  rolling_pnl_pct: number
  max_daily_loss_pct: number
  max_drawdown_pct: number
  would_trip: boolean
  trip_reason: string | null
  currently_paused_plan_count: number
  enabled: boolean
}

export interface IngestUnderlying {
  underlying: string
  rows: number
  snapshot_days: number
  rows_with_delta: number
  delta_coverage_pct: number
  earliest_snapshot: string | null
  latest_snapshot: string | null
}

export interface IngestStatus {
  ok: boolean
  underlyings: IngestUnderlying[]
  now: string
}

export interface ReadinessReport {
  compass_db_url_set: boolean
  scheduler: { enabled: boolean; running: boolean; market_open_now: boolean; job_count: number }
  ws_subscriber: { running: boolean; connected: boolean; events_received: number; reconnects: number }
  live_allow_real_money: boolean
  discord_audit_enabled: boolean
  now: string
}

export const getHealth = () => apiGet<HealthResponse>('/health')
export const getSchedulerStatus = () => apiGet<SchedulerStatus>('/scheduler/status')
export const getWsStatus = () => apiGet<WsStatus>('/ws/status')

export interface CaptureGateway {
  alias: string
  is_default: boolean
  connector: string // 'gateway' | 'ibx'
  connected: boolean
  capture_wired: boolean
}
export interface CaptureStatus {
  ok: boolean
  connector: string // 'gateway' | 'ibx' — what drives the pill label
  default_connected: boolean
  any_connected: boolean
  gateways: CaptureGateway[]
}
export const getCaptureStatus = () => apiGet<CaptureStatus>('/ingest/capture-status')
export const getCircuitBreaker = (alias = 'paper') =>
  apiGet<CircuitBreakerSnapshot>('/circuit_breaker', { params: { account_alias: alias } })
export const getIngestStatus = () => apiGet<IngestStatus>('/ingest/status')
export const getReadiness = () => apiGet<ReadinessReport>('/readiness')
